import React from "react";
import {
    AppBar,
    Toolbar,
    Box,
    Button,
    Typography,
    useMediaQuery 
  } from '@mui/material';
  import { useNavigate,useSearchParams } from "react-router-dom";

const HeaderApp = ({type}) => {
    const [searchParams] = useSearchParams();
    const visitorId = searchParams.get("guid");
    const navigate = useNavigate();
    const isSmallScreen = useMediaQuery(theme => theme.breakpoints.down('sm'));
    const isMediumScreen = useMediaQuery(theme => theme.breakpoints.between('sm', 'md'));
    const isLargeScreen = useMediaQuery(theme => theme.breakpoints.up('md'));
    const handleLoginType = () => {
      localStorage.removeItem("email");
      const guidParam = visitorId ? `?guid=${visitorId}` : "";
      const path = type === 'signup' ? `/login${guidParam}` : `/signup${guidParam}`;
      navigate(path);
    };
    return (
        <AppBar position="static" sx={{ backgroundColor: "transparent", boxShadow: "none", color: "#222222" }}>
        <Toolbar sx={{ display: "flex", justifyContent: "space-between",}}>
          <Box component="img" src={`${process.env.PUBLIC_URL}/images/meon-tech.png`} alt="logo" sx={{ height: isSmallScreen ? 30 : isMediumScreen ? 45 : 45, }} />

          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Typography variant="h6" sx={{ fontWeight: 600, fontSize: isSmallScreen ? "16px" : "18px" }}>
              {type==='signup' ? 'Missed us?' : 'Be Cool!'}
            </Typography>
            <Button
              variant="contained"
              onClick={handleLoginType}
              sx={{
                color: "#fff",
                background: "#185CB7",
                textTransform: "none",
                "&:hover": { background: "#185CB7" },
                padding: "5px 35px",
                borderRadius: "8px",
                fontSize: isSmallScreen? "15px" : "16px",
                fontWeight: "600"
              }}
            >
              {type==='signup' ? 'Login' : 'Sign Up'}
            </Button>
          </Box>
        </Toolbar>
      </AppBar>
    )
}
export default HeaderApp;